import {decorate, observable, action} from 'mobx';
import  {SearchInput }  from "./objects/SearchInput"
// import LocSearcher from "./objects/searchers/LocSearcher"
import {DaataSearcher, UliSearcher} from "./objects/searchers/IsraeliLibsSearchers"
import {OskiCatSearcher, StanfordSearcher, PrincetonSearcher, LoCSimplifiedSearcher} from "./objects/searchers/AmericanUniLibraries"
import {OACSearcher, HuntingtonSearcher, AvalonSearcher} from "./objects/searchers/ArchivesSearchers"
import {GSSSearcher, USCensusSearcher, PewSearcher} from "./objects/searchers/SocialScienceSearchers"
import {JstorSearcher, GoogleScholarSearcher} from "./objects/searchers/ArticlesSearchers"
import Translator from "./objects/Translator"
import {translateText} from "./objects/I18n"
import { message } from 'antd';
import ReactGA from 'react-ga'


class Store {

  state = {
    searchExists : false,
    errorMsg : null,
    awaitingUserSelection : false,
    language : "he",
    accessibilityEnabled : false,
    accessibilityDeclerationOpen : false
  }

  constructor(props) {
    this.searcherGroups = [{
      name: "Israeli libraries" ,
      searchers: [
        new DaataSearcher(),
        new UliSearcher()
      ]
    },
    {
      name: "Online material from worlwide libraries", 
      searchers: [
        new LoCSimplifiedSearcher(),
        new OskiCatSearcher(),
        new StanfordSearcher(),
        new PrincetonSearcher()
      ]
    },
    {
      name: "Article Repositories", 
      searchers: [
        new JstorSearcher(),
        new GoogleScholarSearcher()
      ]
    },
    {
      name: "Social Science Databases", 
      searchers: [
        new GSSSearcher(),
        new USCensusSearcher(),
        new PewSearcher()
      ]
    },
    {
      name: "Archives", 
      searchers: [
        new OACSearcher(),
        new HuntingtonSearcher(),
        new AvalonSearcher()
      ]
    }];
    this.searchInput = new SearchInput(); 
    this.translator = new Translator();
    this.state.accessibilityEnabled = props.accessibilityEnabled ? props.accessibilityEnabled : false;
  }

  search(value) {
    if (value === null) {
      this.clearSearch();
      return;
    }
    this.state.searchExists = true;
    this.state.errorMsg = null;
    message.loading(translateText(this, 'Searching'));
    Promise.all(this.searcherGroups.map(sg => 
      Promise.all(sg.searchers.map(s =>
        s.search(value, this)
      ))
    ))
    .then(() => {
      message.destroy();
    })
    .catch(err => {
      this.handleError(err, 'search', "Encountered error during search", false);
    });
  }

  run() {
    
    let value = this.searchInput.value;
    ReactGA.event({
      category: "Search",
      action: "User searched " + value,
    });
    if (!value) {
      this.handleError("No value was given to search", 'run', "No value was given to search");
    }
    this.searchInput.doTranslate === true ? 
      this.translate(value) :
      this.search(value);
    }    
    
  translate(value) {
    this.state.awaitingUserSelection = false;
    
    message.loading(translateText(this, "Translating"))
    this.translator.translate(value)
    .then( () => {
      this.state.awaitingUserSelection = true;
      message.destroy();
    })
    .catch(err => {
        this.handleError(err, 'translation', "Error when translating input. Try running without translation");
    });
  }

  changeLanguage(language) {
    ReactGA.event({
      category: "LangChange",
      action: "User changed language to " + language,
    });
    this.state.language=language;
    
  }


  handleError(err, source, errMessage, allSearchers=true) {
    message.error(translateText(this, 'Error during ' + source), 4);
    if (allSearchers) {
      this.searcherGroups.forEach(sg => { 
        sg.searchers.forEach(s => {
          s.fillError(err);
        });
      });
    }
    this.state.errorMsg = errMessage;
    throw err;
  }

  clearSearch() {
    this.state.searchExists = false;
    this.searcherGroups.forEach(sg => {
      sg.searchers.forEach(s => {s.clear();});
    });
  }

  toggleAccessibility() {
    this.state.accessibilityDeclerationOpen = false;
    this.state.accessibilityEnabled = !(this.state.accessibilityEnabled);
  }

}


decorate(Store, {
  search : action.bound,
  clearSearch : action.bound,
  run : action.bound,
  searcherGroups : observable,
  searchInput: observable,
  translator : observable,
  state : observable,
  changeLanguage: action.bound,
  toggleAccessibility: action.bound
});

export default Store;